import { combineReducers } from 'redux';
import authReducer from '../modules/login/redux/authReducer';
import labsSetupReducer from '../modules/LabSetup/redux/labsSetupReducer';
import labsStockManagementReducer from '../modules/LabsStockManagement/redux/reducer';
import departmentReducer from "../modules/ActivityTypes/redux/activityTypesReducer";
import userManagerReducer from "../modules/UserManager/redux/userManagerReducer";
import labStatusesReducer from "../modules/LabStatuses/redux/labStatusesReducer";
import varianceStatusesReducer from "../modules/VarianceStatuses/redux/varianceStatusesReducer";
import dashboardReducer from '../modules/Dashboard/redux/reducer';

const rootReducer = combineReducers({
  authReducer: authReducer,
  labsSetupReducer: labsSetupReducer,
  labsStockManagementReducer: labsStockManagementReducer,
  departmentReducer: departmentReducer,
  userManagerReducer: userManagerReducer,
  labStatusesReducer: labStatusesReducer,
  varianceStatusesReducer: varianceStatusesReducer,
  dashboardReducer: dashboardReducer,
});

export default rootReducer;
